import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { Users, FileText, BarChart3, LogOut, Home, Activity, Building2, ScrollText, Network } from 'lucide-react';
import useAuthStore from '../../stores/authStore';
import authApi from '../../services/authApi';
import { toast } from 'react-hot-toast';

const AdminLayout = () => {
  const navigate = useNavigate();
  const { user, logout, accessToken } = useAuthStore();

  const handleLogout = async () => {
    try {
      await authApi.logout(accessToken);
      logout();
      toast.success('Выход выполнен успешно');
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
      logout();
      navigate('/login');
    }
  };

  const navItems = [
    { to: '/admin', icon: Home, label: 'Обзор', end: true },
    { to: '/admin/users', icon: Users, label: 'Пользователи' },
    { to: '/admin/organizations', icon: Building2, label: 'Организации' },
    { to: '/admin/hierarchy', icon: Network, label: 'Иерархия' },
    { to: '/admin/scenarios', icon: FileText, label: 'Сценарии' },
    { to: '/admin/audit-log', icon: ScrollText, label: 'Журнал аудита' },
    { to: '/admin/analytics', icon: BarChart3, label: 'Аналитика' },
    { to: '/admin/services', icon: Activity, label: 'Сервисы' },
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="w-64 bg-white border-r border-gray-200 flex flex-col">
        {/* Logo */}
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-xl font-bold text-gray-900">Savitskaya.ai</h1>
          <p className="text-xs text-gray-500 mt-1">Админ-панель</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${
                  isActive
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-50'
                }`
              }
            >
              <item.icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        {/* User Info & Logout */}
        <div className="p-4 border-t border-gray-200">
          <div className="mb-3 px-4 py-2 bg-gray-50 rounded-lg">
            <p className="text-sm font-medium text-gray-900">
              {user?.firstName || user?.email}
            </p>
            <p className="text-xs text-gray-500">{user?.email}</p>
            <span className="inline-block mt-1 px-2 py-0.5 bg-purple-100 text-purple-700 text-xs font-medium rounded">
              Администратор
            </span>
          </div>
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
          >
            <LogOut className="w-5 h-5" />
            <span className="font-medium">Выйти</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;
